import { ImgProps } from "assets/images/types";

export default function ImgNaturaHomemFooter1(props: ImgProps) {
	const { height = 282, width = 283 } = props;
	return (
		<img
			src="/assets/images/cases/natura-homem-nos/natura-homem-nos-footer-1.webp"
			alt="Eu + Meu Pai = Nós"
			loading="eager"
			width={width}
			height={height}
		/>
	);
}
